export async function saveToCache(sessionId, cache_title,title,messages,timestamp,mode,setChatHistory) {
    try {
        //'chat-history-cache'を呼び出す
        //console.log('saveToCache sessionId:',sessionId);
        //console.log('saveToCache title:',title);//chat-history-cache
        //console.log('saveToCache messages:',messages);
        //console.log('saveToCache ChatHist:',setChatHistory);

        //過去の情報を取得
        const cache = await caches.open(cache_title);//chat-history-cache or chat-file-cache
        const storedSessions = await loadTitleCache(cache_title);

        //console.log('saveToCache storedSessions:',storedSessions);
        let updatedSessions = []

        switch (cache_title) {
        case 'chat-history-cache':
            updatedSessions = storedSessions.map(session => 
                session.id === sessionId 
                    ? { ...session, messages, timestamp: timestamp } 
                    : session
            );
            // 新しいセッションの場合は追加
            if (!updatedSessions.find(session => session.id === sessionId)) {
                console.log('saveToCacheNew',sessionId)
                updatedSessions.push({ id: sessionId,title:title,messages: messages ,timestamp:timestamp,mode:mode});
                //console.log('saveToCacheup',JSON.stringify(updatedSessions))
            }
            //console.log('saveToCache updatedSessions:',updatedSessions)
            setChatHistory(updatedSessions);
            
            // 更新したデータをキャッシュに保存
            await cache.put('chat-sessions', new Response(JSON.stringify(updatedSessions)));

            break
        case 'chat-file-cache': 
            //console.log('storedSessions',storedSessions)
            updatedSessions = storedSessions.map(session => 
                session.id === sessionId 
                    ? { ...session, messages, timestamp: timestamp } 
                    : session
            );
            if (!updatedSessions.find(session => session.id === sessionId)) {
                updatedSessions.push({ id: sessionId,title:title,messages: messages ,timestamp:timestamp,mode:mode});
            }
            //console.log('saveToCache file:',updatedSessions);
            await cache.put('chat-sessions', new Response(JSON.stringify(updatedSessions)));
            break

        case 'chat-bufilenew-cache':
            //console.log('saveToCache file:',messages);
            await cache.put('chat-sessions', new Response(JSON.stringify(messages)));
            break


        case 'chat-bufile-cache':
            //console.log('chat-bufile-cache',storedSessions)

            updatedSessions = storedSessions.map(session => 
                session.id === sessionId
                    ? { ...session, messages, timestamp: timestamp } 
                    : session
            );
            if (!updatedSessions.find(session => session.id === sessionId)) {
                const buId = sessionId.split('/')[0];
                updatedSessions.push({ id: sessionId,title:title,buId:buId,messages: messages ,timestamp:timestamp,mode:mode});
            }
            //console.log('saveToCache file:',updatedSessions);
            await cache.put('chat-sessions', new Response(JSON.stringify(updatedSessions)));
            break

        default:
            return null;
        }


    } catch (error) {
        console.error('Error saving to cache:', error);
    }
}

export const loadFromCache = async (title,sessionId) => {
    //title='chat-history-cache'を呼び出す
    try {
        console.log('loadFromCache title:', title);
        console.log('loadFromCache session:', sessionId);

        const cache = await caches.open(title);
        const cachedResponse = await cache.match('chat-sessions'); // または適切なキャッシュ名

        if (!cachedResponse) return [];

        // キャッシュからデータを取得
        const data = await cachedResponse.json();
        //console.log('Cache_data:', data);

        // sessionId が一致するデータを抽出
        const filteredData = data.filter(item => item.id === sessionId);
        //const filteredData2 = await filteredData.json();
        console.log('', filteredData);

        // 一致するデータがあれば返す、一致しなければ空の配列
        return filteredData.length > 0 ? filteredData : [];

    } catch (error) {
        console.error('Error loading from cache:', error);
        return null;
    }
};

export const loadFromCacheAll = async (title) => { 
    //title='chat-history-cache'を呼び出す
    try {
        console.log('loadFromCache title:', title); //chat-history-cache or chat-file-cache
 
        const cache = await caches.open(title);
        const cachedResponse = await cache.match('chat-sessions'); // または適切なキャッシュ名

        if (!cachedResponse) return [];

        // キャッシュからデータを取得
        const data = await cachedResponse.json();
        //console.log('Cache_data:', data);

        // 一致するデータがあれば返す、一致しなければ空の配列
        return data.length > 0 ? data : [];

    } catch (error) {
        console.error('Error loading from cache:', error);
        return null;
    }
};


export const loadFromCacheBu = async (title,sessionId) => { 
    //title='chat-history-cache'を呼び出す
    try {
        console.log('loadFromCache title:', title); // chat-history-cache or chat-file-cache
        console.log('loadFromCache title:', sessionId); // chat-history-cache or chat-file-cache
        const cache = await caches.open(title);
        const cachedResponse = await cache.match('chat-sessions'); // または適切なキャッシュ名

        if (!cachedResponse) return [];

        const data = await cachedResponse.json();
        console.log('Cache_data:', data);

        // "buId" が "リテイル事業部" に一致するデータだけを返す
        const filteredData = data.filter(item => item.buId === sessionId);

        return filteredData;
    } catch (error) {
        console.error('Error loading from cache:', error);
        return null;
    }
};

export const loadTitleCache = async (cache_title) => {
    try {

        console.log('Cachetitle_loadFromCache:', cache_title);

        const cache = await caches.open(cache_title);
        const cachedResponse = await cache.match('chat-sessions'); // または適切なキャッシュ名
   
        //const sessionData = data.find(item => item.sessionId === sessionId);
        if (!cachedResponse) return [];

        // キャッシュからデータを取得
        const data = await cachedResponse.json();
        //console.log('Cache_title_data:', data);
        if (data && Array.isArray(data)) {

            switch (cache_title) {
            case 'chat-history-cache':
                data.sort((a, b) => b.timestamp - a.timestamp);  // 降順ソート
                break;
            case 'chat-bufilenew-cache':
//                data.sort((a, b) => b.timestamp - a.timestamp); 
                break;
            default:
                data.sort((a, b) => {
                    const categoryA = a.messages.category;
                    const categoryB = b.messages.category;
                    return categoryA.localeCompare(categoryB);
                })
                break;
            };

        }


        return data ? data : [];

    } catch (error) {
        console.error('Error loading from cache:', error);
        return null;
    }
};

export const deleteFromCache = async (cache_title, sessionId) => {
    try {
        console.log('deleteFromCache: 削除対象の sessionId:', sessionId);

        // 指定されたキャッシュを開く
        const cache = await caches.open(cache_title);
        console.log('deleteFromCache:cache:',cache)
        const cachedResponse = await cache.match('chat-sessions');

        if (!cachedResponse) {
            console.log('deleteFromCache: キャッシュが見つかりません');
            return;
        }

        // キャッシュデータを取得
        const data = await cachedResponse.json();
        console.log('deleteFromCache: キャッシュの中身', data);

        // 指定の sessionId を削除
        const updatedData = data.filter(item => item.id !== sessionId);

        // キャッシュを更新（削除後のデータを保存）
        await cache.put('chat-sessions', new Response(JSON.stringify(updatedData)));

        console.log('deleteFromCache: 削除後のキャッシュ', updatedData);
    } catch (error) {
        console.error('Error deleting from cache:', error);
    }
};

export const clearCache = async () => {
    try {
        // すべてのキャッシュストレージの名前を取得
        const cacheNames = await caches.keys();
        
        // すべてのキャッシュを削除
        await Promise.all(
            cacheNames.map(cacheName => caches.delete(cacheName))
        );

        console.log('✅ すべてのキャッシュをクリアしました！', cacheNames);
    } catch (error) {
        console.error('❌ キャッシュのクリアに失敗しました:', error);
    }
};